export default "__VITE_ASSET__CsLuw9Aj__"